/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { VERIFY_PHONE } from '@pages/MyProfilePage/apis/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/MyProfilePage/config/api.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IVerifyOTPMethods extends IPluginMethodMap {
  getVerifyOTP(args: any): Promise<any>;
}

export interface verifyOTPProps {
  otp?: string;
}

export class VerifyOTPPlugin implements IAgentPlugin {
  readonly methods: IVerifyOTPMethods;

  constructor() {
    this.methods = {
      getVerifyOTP: this.getVerifyOTP.bind(this),
    };
  }

  async getVerifyOTP(args: verifyOTPProps) {
    return await this.verifyOTP(args);
  }

  private async verifyOTP(args: verifyOTPProps) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(VERIFY_PHONE, {
          otp: args?.otp,
        })
        .toPromise();
      if (res?.data?.verifyMobileNo) {
        return {
          data: res?.data?.verifyMobileNo?.message,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
}
